import { useDispatch, useSelector } from 'react-redux';
import { updateThemeAttribute } from '../redux/dashboardSlice';
import { useCallback, useEffect, useRef, useState } from 'react';
import { cloneDeep, debounce, set } from 'lodash';

export const useSetThemeAttribute = () => {
  const dispatch = useDispatch();

  return (path, value) => {
    dispatch(updateThemeAttribute({ path, value }));
  };
}

export function useLocalDebouncedTheme() {
  const globalTheme = useSelector(s => s.dashboard.theme);
  const setAttribute = useSetThemeAttribute();
  const [theme, setTheme] = useState(globalTheme);

  useEffect(() => {
    setTheme(globalTheme);
  }, [globalTheme]);

  const dispatchDebounced = useRef(
    debounce((path, value) => {
      setAttribute(path, value)
    }, 300)
  ).current;

  const update = useCallback((path, value) => {
    setTheme(prev => {
      const next = cloneDeep(prev)
      set(next, path, value)
      return next
    });
    dispatchDebounced(path, value);
  }, [dispatchDebounced])

  return [theme, update];
}